function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M188.315 24.2841V21.5H154.593V24.2841H188.315Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M119.221 24.2841V21.5H85.5V24.2841H119.221Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M241.894 24.3352H260.212V21.5H241.894H223.576V24.3352H241.894Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M329.4 24.2841V21.5H295.678V24.2841H329.4Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M382.979 24.3352H401.297V21.5H382.979H364.661V24.3352H382.979Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M470.485 24.2841V21.5H436.763V24.2841H470.485Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M524.064 24.3352H542.382V21.5H524.064H505.746V24.3352H524.064Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M611.569 24.2841V21.5H577.848V24.2841H611.569Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M665.149 24.3352H683.467V21.5H665.149H646.831V24.3352H665.149Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M752.654 24.2841V21.5H718.933V24.2841H752.654Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M796.645 24.8983L796.67 24.8996L796.696 24.9035L805.206 26.209L805.433 24.8063L806.424 24.9401L806.272 26.3435C807.773 26.5531 809.248 26.9449 810.772 27.3497C810.988 27.4071 811.205 27.4647 811.423 27.5221L811.423 27.522L811.433 27.5249C812.502 27.8301 813.617 28.1341 814.678 28.387C817.48 28.9776 820.093 29.94 822.919 30.9937L823.896 28.4012C821.033 27.3351 818.2 26.3039 815.283 25.6822L815.274 25.6803L815.266 25.6782C815.098 25.6364 814.929 25.5943 814.758 25.5519C813.895 25.3382 812.996 25.1151 812.132 24.8563C812.001 24.8217 811.869 24.7869 811.736 24.752C809.91 24.2698 808.036 23.7752 806.122 23.5417L806.122 23.5419L806.108 23.5399L796.927 22.1627L787.946 21.6799L787.833 24.4625L796.645 24.8983Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M871.195 64.8016L871.213 64.8218L871.228 64.8438C871.935 65.8539 872.797 66.9694 873.613 67.9887L873.613 67.9886L873.62 67.9985C873.873 68.3316 874.132 68.6671 874.392 69.0049C875.018 69.817 875.655 70.6434 876.256 71.487L878.504 69.8761C877.631 68.6827 876.757 67.4934 875.843 66.3047L875.841 66.3029L875.84 66.3009C875.027 65.2343 874.211 64.1627 873.394 63.04C868.63 57.6248 862.362 50.9084 854.97 45.3776L853.312 47.6388C860.545 53.0382 866.67 59.6227 871.195 64.8016Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M894.151 101.286L891.482 102.038C891.501 102.106 891.52 102.173 891.539 102.24C893.071 107.644 894.665 113.267 895.344 118.989L896.742 118.838L896.876 119.828L895.474 120.056L896.114 124.167L896.117 124.191L896.119 124.215C896.17 125.085 896.221 126.058 896.272 127.028C896.272 127.028 896.272 127.029 896.272 127.029L896.272 127.03L896.374 128.714L896.375 128.729V128.744C896.375 129.438 896.418 130.142 896.463 130.869C896.486 131.253 896.51 131.644 896.528 132.043C896.528 132.044 896.528 132.044 896.528 132.045L896.529 132.051C896.622 133.824 896.716 135.615 896.692 137.411L899.486 137.486C899.534 135.933 899.451 134.406 899.367 132.86C899.349 132.52 899.331 132.179 899.313 131.837L899.313 131.836C899.288 131.299 899.262 130.749 899.237 130.199C899.211 129.649 899.186 129.1 899.16 128.563L899.16 128.563L899.16 128.555L899.109 126.923C899.058 125.854 899.007 124.849 898.908 123.846L898.194 119.154L898.192 119.147L898.191 119.139C897.45 112.964 895.796 107.023 894.151 101.286Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M894.017 172.48L891.339 171.612C887.901 182.167 882.916 192.138 876.476 201.288L878.777 202.91C885.363 193.486 890.459 183.25 894.017 172.48Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M830.725 242.272L838.752 238.403L838.153 237.166L839.033 236.693L839.751 237.903C844.974 234.851 850.026 231.797 854.67 228.127L852.896 225.938C848.262 229.609 843.156 232.659 837.934 235.693L837.916 235.703L837.898 235.712L829.563 239.7L829.556 239.704L829.549 239.707C827.795 240.481 825.94 241.15 824.105 241.813L824.101 241.815C823.626 241.995 823.168 242.16 822.719 242.322C822.275 242.483 821.839 242.64 821.404 242.806L822.42 245.402C823.296 245.064 824.17 244.758 825.035 244.455L825.04 244.454L825.043 244.452C826.973 243.792 828.85 243.082 830.725 242.272Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M765.12 248.954H753.705V251.738H765.12C772.569 251.738 780.019 251.689 787.42 251.591L787.382 248.807C779.977 248.905 772.524 248.954 765.12 248.954Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M700.126 248.954H681.808V251.738H700.126H718.444V248.954H700.126Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M646.342 251.738V248.954H612.621V251.738H646.342Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M559.041 248.954H540.774V251.738H559.041H577.359V248.954H559.041Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M505.257 251.738V248.954H471.536V251.738H505.257Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M418.008 248.954H399.689V251.738H418.008H436.275V248.954H418.008Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M364.172 251.738V248.954H330.451V251.738H364.172Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M276.923 248.954H258.604V251.738H276.923H295.241V248.954H276.923Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M223.088 251.738V248.954H189.366V251.738H223.088Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M135.838 248.954H117.52V251.738H135.838H154.156V248.954H135.838Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M52.8729 271.586C62.119 265.247 72.1369 260.313 82.645 256.973L81.8159 254.297C71.0462 257.709 60.7605 262.753 51.2862 269.243L52.8729 271.586Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6195 301.288L14.8784 308.932L16.0764 309.643L15.603 310.523L14.3653 309.923L10.4415 318.013L10.4416 318.013L10.4364 318.023C9.48355 319.878 8.77807 321.891 8.11246 323.837L8.1113 323.84L8.10977 323.845C7.80688 324.71 7.50101 325.584 7.16279 326.46L9.755 327.474C10.1028 326.559 10.4423 325.651 10.7446 324.744L10.7445 324.744L10.7472 324.737C11.4105 322.849 12.0847 320.979 12.9707 319.258L17.1105 310.774L17.1204 310.754L17.132 310.735L21.99 302.706L21.9947 302.698L21.9997 302.691C23.0838 301.039 24.2687 299.442 25.4996 297.852L25.5003 297.851C26.1083 297.07 26.6772 296.328 27.2398 295.561L24.9845 293.945C24.4135 294.723 23.8434 295.469 23.2768 296.21L23.2765 296.21C23.2763 296.21 23.2761 296.211 23.2758 296.211C23.1143 296.424 22.9532 296.636 22.7926 296.847C21.6765 298.315 20.5907 299.743 19.6202 301.287C19.62 301.287 19.6197 301.288 19.6195 301.288Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M0.571279 365.505C0.571279 375.827 1.90253 385.999 4.56402 395.779L7.22883 395.066C4.64615 385.555 3.35538 375.604 3.35538 365.556V365.549C3.35538 364.389 3.35538 363.259 3.38989 362.098L0.605235 361.985C0.571365 363.147 0.571279 364.341 0.571279 365.505Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6671 436.04L24.6682 436.042C26.2845 438.351 28.1975 440.45 30.0835 442.52C30.1589 442.603 30.2342 442.686 30.3095 442.768L32.5111 441.164C30.3314 438.794 28.4842 436.769 26.9137 434.463C26.2581 433.504 25.6013 432.645 24.8866 431.726L24.8866 431.726L24.8813 431.719C24.716 431.499 24.5508 431.28 24.3865 431.063C23.4463 429.818 22.5328 428.609 21.7656 427.29L19.3225 428.643C20.3284 430.333 21.5314 431.905 22.7094 433.413L22.7094 433.413L22.7126 433.417L22.7162 433.422C23.3787 434.288 24.0481 435.163 24.6671 436.04Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M36.1138 445.004L36.1137 445.004L36.1059 444.995L33.2712 441.795L31.2014 443.676L34.036 446.831C34.7872 447.632 35.5403 448.335 36.3492 449.043L36.3493 449.043L36.3578 449.051L37.5808 450.172C38.3446 450.84 39.0638 451.508 39.7332 452.13C39.7853 452.178 39.837 452.227 39.8885 452.274L39.8899 452.276L39.9084 452.293C41.3746 453.665 42.8571 455.052 44.5343 456.24L46.1175 453.941C44.606 452.848 43.2188 451.555 41.8151 450.245C41.046 449.527 40.2913 448.823 39.4887 448.171L39.4771 448.161L39.4661 448.151L38.2389 447.026L38.2389 447.026L38.2365 447.024C38.0614 446.862 37.8833 446.699 37.7039 446.536C37.1695 446.05 36.6241 445.553 36.1138 445.004Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M88.6435 474.966L88.6305 474.964L88.6176 474.96L86.4245 474.399L86.4185 474.398C85.0965 474.093 83.7452 473.781 82.3905 473.312L82.3905 473.312L82.3829 473.309L76.8216 471.283L75.8792 473.921L81.5405 475.997C82.7908 476.399 84.041 476.722 85.2721 477.039C85.4306 477.08 85.5889 477.121 85.7468 477.162C85.7471 477.162 85.7474 477.162 85.7477 477.162L87.9294 477.72C88.7636 477.878 89.4934 478.086 90.2004 478.288C90.5199 478.368 90.8335 478.45 91.1437 478.53C92.2469 478.817 93.307 479.092 94.4348 479.248L94.4348 479.248L94.441 479.249L100.883 480.22C100.883 480.22 100.884 480.22 100.884 480.22C103.479 480.605 106.17 480.853 109.133 481.052L109.284 478.265C106.398 478.06 103.781 477.766 101.304 477.426L101.304 477.426L101.298 477.425L94.863 476.455C93.4972 476.296 92.1896 475.93 90.9257 475.576L90.9108 475.572C90.6339 475.498 90.3684 475.421 90.109 475.346C89.611 475.202 89.1353 475.065 88.6435 474.966Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M163.093 481.442H181.412V478.658H163.093H144.775V481.442H163.093Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M250.599 481.442V478.658H216.877V481.442H250.599Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M304.178 481.442H322.496V478.658H304.178H285.86V481.442H304.178Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M391.684 481.442V478.658H357.962V481.442H391.684Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M445.263 481.442H463.581V478.658H445.263H426.945V481.442H445.263Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M532.769 481.442V478.658H499.047V481.442H532.769Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M586.297 481.442H604.666V478.658H586.297H568.03V481.442H586.297Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M673.853 481.442V478.658H640.132V481.442H673.853Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M727.382 481.442H745.7V478.658H727.382H709.115V481.442H727.382Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M782.302 481.442C793.758 481.442 804.477 482.733 814.214 485.269L814.928 482.603C804.977 479.99 793.989 478.658 782.302 478.658H781.172L781.21 481.442H782.302Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M856.289 507.007L856.309 507.023L856.329 507.04L859.337 509.821L860.276 508.807L861.022 509.472L860.12 510.524C864.707 514.5 868.692 519.126 872.106 523.169L874.26 521.356C870.698 517.057 866.48 512.237 861.647 508.094L861.632 508.082L861.618 508.068L861.576 508.025L858.175 504.929L852.364 500.545L852.364 500.545C850.598 499.209 848.861 497.896 846.927 496.788L845.572 499.236C847.094 500.11 848.499 501.169 849.943 502.259C850.165 502.426 850.388 502.595 850.612 502.763C850.613 502.763 850.613 502.763 850.613 502.763L856.289 507.007Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M896.34 585.471L899.128 585.283C898.338 573.714 895.914 562.537 891.857 552.031L889.209 553.052C893.153 563.344 895.545 574.214 896.34 585.471Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M882.387 653.885C885.617 648.955 888.138 643.569 890.517 638.012L889.23 637.444L889.606 636.518L890.926 637.008L893.971 628.743C894.512 627.079 894.915 625.485 895.327 623.856C895.415 623.508 895.504 623.157 895.595 622.804L895.595 622.804C895.811 621.894 896.03 620.976 896.281 620.055L893.632 619.346C893.539 619.726 893.441 620.109 893.343 620.489L893.343 620.491C893.202 621.042 893.062 621.587 892.936 622.12L892.936 622.12L892.935 622.122C892.905 622.247 892.874 622.371 892.844 622.497C892.414 624.267 891.97 626.096 891.39 627.838L891.39 627.838L891.385 627.851L888.266 636.441L888.259 636.459L888.252 636.476C885.765 641.997 883.217 647.402 880.047 652.337L882.387 653.885Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M830.483 698.819C841.239 694.226 850.932 688.193 859.375 680.815L857.527 678.703C849.305 685.85 839.83 691.733 829.387 696.212L830.483 698.819Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M778.262 708.18H778.278L778.293 708.181C779.091 708.231 779.888 708.231 780.685 708.181L780.701 708.18H780.717C785.866 708.18 791.019 707.925 796.027 707.618L796.027 707.618L796.034 707.618L796.605 707.591L796.454 704.805L795.878 704.832C795.391 704.859 794.902 704.885 794.412 704.912C789.313 705.188 784.085 705.472 778.851 705.403L778.813 706.801L777.813 706.788V705.396H759.995V708.18H778.262Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M724.529 708.18V705.396H690.808V708.18H724.529Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M637.228 705.396H618.91V708.18H637.228H655.547V705.396H637.228Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M583.445 708.18V705.396H549.723V708.18H583.445Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M496.144 705.396H477.825V708.18H496.144H514.462V705.396H496.144Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M442.36 708.18V705.396H408.638V708.18H442.36Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M355.059 705.396H336.741V708.18H355.059H373.377V705.396H355.059Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M301.275 708.18V705.396H267.553V708.18H301.275Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M213.974 705.396H195.656V708.18H213.974H232.292V705.396H213.974Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M160.19 708.181V705.396H126.469V708.185L131.337 708.231L131.34 708.231L160.19 708.181Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M82.1911 710.641L73.6349 713.783L74.125 715.102L73.1988 715.478L72.6321 714.194C67.2362 716.532 61.6166 719.058 56.3974 722.429L57.9014 724.76C63.1412 721.394 68.7934 718.847 74.1235 716.556L74.1365 716.55L74.1499 716.545L82.9964 713.324L83.0197 713.315L83.0437 713.309L91.5618 711.131L90.8839 708.419L82.1911 710.641Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9682 747.482L28.9017 745.641C21.4239 754.085 15.2914 763.727 10.5988 774.29L13.1124 775.416C17.6919 765.121 23.675 755.747 30.9682 747.482Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M5.45926 845.095L5.45922 845.095L5.45831 845.089C5.43968 844.974 5.42103 844.859 5.40237 844.744C4.52579 839.341 3.61314 833.715 3.51522 828.123H2.11668L2.08968 827.123L3.48332 827.048C3.33996 824.275 3.21537 821.263 3.45847 818.335C3.50949 817.162 3.5605 816.04 3.61149 814.918L3.61148 814.918L3.61163 814.915C3.63123 814.533 3.64899 814.151 3.66676 813.769C3.73337 812.336 3.80009 810.901 3.96413 809.444L1.22442 809.106C1.01384 810.973 0.920413 812.882 0.826333 814.811C0.800766 815.374 0.775202 815.923 0.749651 816.473L0.749644 816.473C0.724079 817.022 0.698527 817.572 0.672975 818.134L0.67243 818.146L0.671308 818.158C0.368475 821.388 0.519255 824.678 0.723605 827.794L0.724538 827.809L0.724658 827.823C0.775408 833.811 1.73969 839.757 2.71181 845.538C2.71189 845.539 2.71197 845.539 2.71205 845.54L2.83122 846.225L5.57731 845.773L5.45926 845.095Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9561 899.311L32.9487 899.304L32.9417 899.296C27.1473 892.998 22.094 886.106 17.8307 878.621L15.4288 879.972C19.8109 887.697 25.1226 894.883 31.1726 901.483L34.0324 904.598C34.033 904.599 34.0336 904.6 34.0342 904.6C34.786 905.402 35.5397 906.106 36.3492 906.814L36.3618 906.825L36.3736 906.837L36.578 907.041L36.5781 907.042L36.5783 907.042L36.5786 907.042L36.5789 907.042L36.5792 907.043L36.5795 907.043L36.5798 907.043L36.5801 907.044L36.5804 907.044L36.5807 907.044L36.581 907.044L36.5813 907.045L36.5816 907.045L36.5819 907.045L36.5822 907.046L36.5825 907.046L36.5828 907.046L36.5831 907.047L36.5834 907.047L36.5837 907.047L36.584 907.047L36.5843 907.048L36.5846 907.048L36.5849 907.048L36.5852 907.049L36.5855 907.049L36.5858 907.049L36.5861 907.05L36.5864 907.05L36.5867 907.05L36.587 907.05L36.5873 907.051L36.5876 907.051L36.5879 907.051L36.5882 907.052L36.5885 907.052L36.5888 907.052L36.5891 907.053L36.5894 907.053L36.5897 907.053L36.59 907.053L36.5903 907.054L36.5906 907.054L36.5909 907.054L36.5912 907.055L36.5915 907.055L36.5918 907.055L36.5921 907.056L36.5924 907.056L36.5927 907.056L36.593 907.056L36.5933 907.057L36.5936 907.057L36.5939 907.057L36.5942 907.058L36.5945 907.058L36.5948 907.058L36.5951 907.059L36.5954 907.059L36.5957 907.059L36.596 907.059L36.5963 907.06L36.5966 907.06L36.5969 907.06L36.5972 907.061L36.5975 907.061L36.5978 907.061L36.5981 907.062L36.5984 907.062L36.5987 907.062L36.599 907.062L36.5993 907.063L36.5996 907.063L36.5999 907.063L36.6002 907.064L36.6005 907.064L36.6008 907.064L36.6011 907.065L36.6014 907.065L36.6017 907.065L36.602 907.065L36.6023 907.066L36.6026 907.066L36.6029 907.066L36.6032 907.067L36.6035 907.067L36.6038 907.067L36.6041 907.068L36.6044 907.068L36.6047 907.068L36.605 907.068L36.6053 907.069L36.6056 907.069L36.6059 907.069L36.6062 907.07L36.6065 907.07L36.6068 907.07L36.6071 907.071L36.6074 907.071L36.6077 907.071L36.608 907.071L36.6083 907.072L36.6086 907.072L36.6089 907.072L36.6092 907.073L36.6095 907.073L36.6098 907.073L36.6101 907.074L36.6104 907.074L36.6107 907.074L36.611 907.074L36.6113 907.075L36.6116 907.075L36.6119 907.075L36.6122 907.076L36.6125 907.076L36.6128 907.076L36.6131 907.077L36.6134 907.077L36.6137 907.077L36.614 907.077L36.6143 907.078L36.6146 907.078L36.6149 907.078L36.6152 907.079L36.6155 907.079L36.6158 907.079L36.6161 907.08L36.6164 907.08L36.6167 907.08L36.617 907.08L36.6173 907.081L36.6176 907.081L36.6179 907.081L36.6182 907.082L36.6185 907.082L36.6188 907.082L36.6191 907.083L36.6194 907.083L36.6197 907.083L36.62 907.083L36.6203 907.084L36.6206 907.084L36.6209 907.084L36.6212 907.085L36.6215 907.085L36.6218 907.085L36.6221 907.086L36.6224 907.086L36.6227 907.086L36.623 907.086L36.6233 907.087L36.6236 907.087L36.6239 907.087L36.6242 907.088L36.6245 907.088L36.6248 907.088L36.6251 907.089L36.6254 907.089L36.6257 907.089L36.626 907.089L36.6263 907.09L36.6265 907.09L36.6268 907.09L36.6271 907.091L36.6274 907.091L36.6277 907.091L36.628 907.092L36.6283 907.092L36.6286 907.092L36.6289 907.092L36.6292 907.093L36.6295 907.093L36.6298 907.093L36.6301 907.094L36.6304 907.094L36.6307 907.094L36.631 907.095L36.6313 907.095L36.6316 907.095L36.6319 907.095L36.6322 907.096L36.6325 907.096L36.6328 907.096L36.6331 907.097L36.6334 907.097L36.6337 907.097L36.634 907.098L36.6343 907.098L36.6346 907.098L36.6349 907.098L36.6352 907.099L36.6355 907.099L36.6358 907.099L36.6361 907.1L36.6364 907.1L36.6367 907.1L36.637 907.1L36.6373 907.101L36.6376 907.101L36.6379 907.101L36.6382 907.102L36.6385 907.102L36.6388 907.102L36.6391 907.103L36.6394 907.103L36.6397 907.103L36.64 907.103L36.6403 907.104L36.6406 907.104L36.6409 907.104L36.6412 907.105L36.6415 907.105L36.6418 907.105L36.6421 907.106L36.6424 907.106L36.6427 907.106L36.643 907.106L36.6433 907.107L36.6436 907.107L36.6439 907.107L36.6442 907.108L36.6445 907.108L36.6448 907.108L36.6451 907.109L36.6454 907.109L36.6457 907.109L36.646 907.109L36.6463 907.11L36.6466 907.11L36.6469 907.11L36.6472 907.111L36.6475 907.111L36.6478 907.111L36.6481 907.112L36.6484 907.112L36.6487 907.112L36.649 907.112L36.6493 907.113L36.6496 907.113L36.6499 907.113L36.6502 907.114L36.6505 907.114L36.6508 907.114L36.6511 907.115L36.6514 907.115L36.6517 907.115L36.652 907.115L36.6523 907.116L36.6526 907.116L36.6529 907.116L36.6532 907.117L36.6535 907.117L36.6538 907.117L36.6541 907.118L36.6544 907.118L36.6547 907.118L36.655 907.118L36.6553 907.119L36.6556 907.119L36.6559 907.119L36.6562 907.12L36.6565 907.12L36.6568 907.12L36.6571 907.121L36.6574 907.121L36.6577 907.121L36.658 907.121L36.6583 907.122L36.6586 907.122L36.6589 907.122L36.6592 907.123L36.6595 907.123L36.6598 907.123L36.6601 907.124L36.6604 907.124L36.6607 907.124L36.661 907.124L36.6613 907.125L36.6616 907.125L36.6619 907.125L36.6622 907.126L36.6625 907.126L36.6628 907.126L36.6631 907.127L36.6634 907.127L36.6637 907.127L36.664 907.127L36.6643 907.128L36.6646 907.128L36.6649 907.128L36.6652 907.129L36.6655 907.129L36.6658 907.129L36.6661 907.13L36.6664 907.13L36.6667 907.13L36.667 907.13L36.6673 907.131L36.6676 907.131L36.6679 907.131L36.6682 907.132L36.6685 907.132L36.6688 907.132L36.6691 907.133L36.6694 907.133L36.6697 907.133L36.67 907.133L36.6703 907.134L36.6706 907.134L36.6709 907.134L36.6712 907.135L36.6715 907.135L36.6718 907.135L36.6721 907.136L36.6724 907.136L36.6727 907.136L36.673 907.136L36.6733 907.137L36.6736 907.137L36.6739 907.137L36.6742 907.138L36.6745 907.138L36.6748 907.138L36.6751 907.139L36.6754 907.139L36.6757 907.139L36.676 907.139L36.6763 907.14L36.6766 907.14L36.6769 907.14L36.6772 907.141L36.6775 907.141L36.6778 907.141L36.6781 907.142L36.6784 907.142L36.6787 907.142L36.679 907.142L36.6793 907.143L36.6796 907.143L36.6799 907.143L36.6802 907.144L36.6805 907.144L36.6808 907.144L36.6811 907.145L36.6814 907.145L36.6817 907.145L36.682 907.145L36.6823 907.146L36.6826 907.146L36.6829 907.146L36.6832 907.147L36.6835 907.147L36.6838 907.147L36.6841 907.148L36.6844 907.148L36.6847 907.148L36.685 907.148L36.6853 907.149L36.6856 907.149L36.6859 907.149L36.6862 907.15L36.6865 907.15L36.6868 907.15L36.6871 907.151L36.6874 907.151L36.6877 907.151L36.688 907.151L36.6883 907.152L36.6886 907.152L36.6889 907.152L36.6892 907.153L36.6895 907.153L36.6898 907.153L36.6901 907.154L36.6904 907.154L36.6907 907.154L36.691 907.154L36.6913 907.155L36.6916 907.155L36.6919 907.155L36.6922 907.156L36.6925 907.156L36.6928 907.156L36.6931 907.157L36.6934 907.157L36.6937 907.157L36.694 907.157L36.6943 907.158L36.6946 907.158L36.6949 907.158L36.6952 907.159L36.6955 907.159L36.6958 907.159L36.6961 907.16L36.6964 907.16L36.6967 907.16L36.697 907.16L36.6973 907.161L36.6976 907.161L36.6979 907.161L36.6982 907.162L36.6985 907.162L36.6988 907.162L36.6991 907.163L36.6994 907.163L36.6997 907.163L36.7 907.163L36.7003 907.164L36.7006 907.164L36.7009 907.164L36.7012 907.165L36.7015 907.165L36.7018 907.165L36.7021 907.166L36.7024 907.166L36.7027 907.166L36.703 907.166L36.7032 907.167L36.7035 907.167L36.7038 907.167L36.7041 907.168L36.7044 907.168L36.7047 907.168L36.705 907.169L36.7053 907.169L36.7056 907.169L36.7059 907.169L36.7062 907.17L36.7065 907.17L36.7068 907.17L36.7071 907.171L36.7074 907.171L36.7077 907.171L36.708 907.172L36.7083 907.172L36.7086 907.172L36.7089 907.172L36.7092 907.173L36.7095 907.173L36.7098 907.173L36.7101 907.174L36.7104 907.174L36.7107 907.174L36.711 907.175L36.7113 907.175L36.7116 907.175L36.7119 907.175L36.7122 907.176L36.7125 907.176L36.7128 907.176L36.7131 907.177L36.7134 907.177L36.7137 907.177L36.714 907.177L36.7143 907.178L36.7146 907.178L36.7149 907.178L36.7152 907.179L36.7155 907.179L36.7158 907.179L36.7161 907.18L36.7164 907.18L36.7167 907.18L36.717 907.18L36.7173 907.181L36.7176 907.181L36.7179 907.181L36.7182 907.182L36.7185 907.182L36.7188 907.182L36.7191 907.183L36.7194 907.183L36.7197 907.183L36.72 907.183L36.7203 907.184L36.7206 907.184L37.5764 907.939C37.5766 907.939 37.5768 907.939 37.577 907.94C38.3422 908.609 39.0628 909.279 39.7332 909.901C39.7853 909.95 39.8371 909.998 39.8885 910.046L39.8899 910.047L39.9083 910.064C41.3746 911.436 42.8571 912.823 44.5343 914.011L46.1175 911.712C44.606 910.619 43.2188 909.326 41.8151 908.016C41.046 907.298 40.2913 906.594 39.4887 905.942L39.4742 905.93L39.4607 905.918L38.5403 905.048C36.689 903.3 34.9432 901.451 33.2553 899.61L32.9561 899.311Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2232 924.996L65.942 927.483C70.4323 929.805 75.2116 931.575 80.1581 933.257L80.1581 933.257L80.1708 933.261L81.5263 933.763C81.6254 933.789 81.713 933.814 81.7939 933.837L81.7964 933.838C81.8865 933.863 81.9685 933.887 82.0616 933.91L82.0892 933.917L82.1159 933.927C82.2943 933.994 82.4745 934.051 82.6675 934.111V934.102L83.2964 934.27C83.6378 934.361 83.9711 934.456 84.3044 934.552C84.7597 934.683 85.2153 934.813 85.6922 934.933L85.6948 934.933L87.8781 935.492C88.7124 935.649 89.4422 935.858 90.1492 936.06C90.4686 936.14 90.7822 936.221 91.0924 936.302C92.1956 936.588 93.2558 936.863 94.3836 937.019L94.3836 937.019L94.3898 937.02L100.832 937.991C100.832 937.991 100.832 937.991 100.833 937.991C103.428 938.376 106.119 938.625 109.082 938.823L109.233 936.036C106.347 935.831 103.73 935.537 101.253 935.197L101.253 935.197L101.246 935.196L94.8117 934.226C93.4459 934.067 92.1384 933.701 90.8744 933.347L90.8596 933.343L88.5663 932.732L88.5614 932.73L86.3675 932.169L86.3675 932.169L86.3599 932.167C85.7961 932.013 85.2453 931.86 84.6962 931.706L84.6951 931.706C84.1451 931.553 83.5968 931.4 83.036 931.247L83.0282 931.245L83.0205 931.242C82.8991 931.205 82.7745 931.167 82.6477 931.129C82.0962 930.961 81.503 930.782 80.9463 930.568L76.3508 928.883C76.3502 928.882 76.3497 928.882 76.3491 928.882C73.2238 927.759 70.1363 926.493 67.2232 924.996Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M163.093 939.213H181.412V936.429H163.093H144.775V939.213H163.093Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M250.599 939.213V936.429H216.877V939.213H250.599Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M304.178 939.213H322.496V936.429H304.178H285.86V939.213H304.178Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M391.684 939.213V936.429H357.962V939.213H391.684Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M445.263 939.213H463.581V936.429H445.263H426.945V939.213H445.263Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M532.769 939.213V936.429H499.047V939.213H532.769Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M586.297 939.213H604.666V936.429H586.297H568.03V939.213H586.297Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M673.853 939.213V936.429H640.132V939.213H673.853Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M727.382 939.213H745.7V936.429H727.382H709.115V939.213H727.382Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M782.302 939.213C793.758 939.213 804.477 940.504 814.214 943.04L814.928 940.375C804.977 937.762 793.989 936.429 782.302 936.429H781.172L781.21 939.213H782.302Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M856.289 964.779L856.311 964.795L856.331 964.814L859.237 967.538L860.173 966.527L860.92 967.192L860.018 968.245C864.604 972.22 868.59 976.846 872.004 980.889L874.157 979.076C870.596 974.777 866.378 969.957 861.544 965.814L861.53 965.802L861.516 965.788L861.473 965.745L858.074 962.65L852.264 958.318L852.261 958.316C850.499 956.983 848.765 955.672 846.836 954.566L845.561 957.002C847.088 957.876 848.495 958.938 849.943 960.03C850.165 960.198 850.388 960.366 850.612 960.534C850.613 960.534 850.613 960.535 850.613 960.535L856.289 964.779Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M896.34 1043.24L899.128 1043.05C898.338 1031.49 895.914 1020.31 891.857 1009.8L889.209 1010.82C893.153 1021.12 895.545 1031.99 896.34 1043.24Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M882.387 1111.66C885.617 1106.73 888.138 1101.34 890.517 1095.78L889.23 1095.22L889.606 1094.29L890.926 1094.78L893.971 1086.51C894.512 1084.85 894.915 1083.26 895.327 1081.63C895.415 1081.28 895.504 1080.93 895.595 1080.58L895.595 1080.57C895.811 1079.67 896.03 1078.75 896.281 1077.83L893.632 1077.12C893.539 1077.5 893.441 1077.88 893.343 1078.26L893.343 1078.26C893.202 1078.81 893.062 1079.36 892.936 1079.89L892.936 1079.89L892.935 1079.89C892.905 1080.02 892.874 1080.14 892.844 1080.27C892.414 1082.04 891.97 1083.87 891.39 1085.61L891.39 1085.61L891.385 1085.62L888.266 1094.21L888.259 1094.23L888.252 1094.25C885.765 1099.77 883.217 1105.17 880.047 1110.11L882.387 1111.66Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M830.483 1156.59C841.239 1152 850.932 1145.96 859.375 1138.59L857.527 1136.47C849.305 1143.62 839.83 1149.5 829.387 1153.98L830.483 1156.59Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M794.412 1162.73C789.313 1163.01 784.085 1163.29 778.851 1163.23L778.813 1164.62L777.813 1164.61V1163.22H759.995V1166H778.262H778.267H778.272H778.277H778.281H778.286H778.291H778.296H778.3H778.305H778.31H778.315H778.32H778.324H778.329H778.334H778.339H778.344H778.348H778.353H778.358H778.363H778.368H778.372H778.377H778.382H778.387H778.392H778.396H778.401H778.406H778.411H778.416H778.42H778.425H778.43H778.435H778.439H778.444H778.449H778.454H778.459H778.463H778.468H778.473H778.478H778.483H778.487H778.492H778.497H778.502H778.507H778.511H778.516H778.521H778.526H778.531H778.535H778.54H778.545H778.55H778.555H778.559H778.564H778.569H778.574H778.579H778.583H778.588H778.593H778.598H778.602H778.607H778.612H778.617H778.622H778.626H778.631H778.636H778.641H778.646H778.65H778.655H778.66H778.665H778.67H778.674H778.679H778.684H778.689H778.694H778.698H778.703H778.708H778.713H778.718H778.722H778.727H778.732H778.737H778.742H778.746H778.751H778.756H778.761H778.765H778.77H778.775H778.78H778.785H778.789H778.794H778.799H778.804H778.809H778.813H778.818H778.823H778.828H778.833H778.837H778.842H778.847H778.852H778.857H778.861H778.866H778.871H778.876H778.881H778.885H778.89H778.895H778.9H778.905H778.909H778.914H778.919H778.924H778.928H778.933H778.938H778.943H778.948H778.952H778.957H778.962H778.967H778.972H778.976H778.981H778.986H778.991H778.996H779H779.005H779.01H779.015H779.02H779.024H779.029H779.034H779.039H779.044H779.048H779.053H779.058H779.063H779.068H779.072H779.077H779.082H779.087H779.091H779.096H779.101H779.106H779.111H779.115H779.12H779.125H779.13H779.135H779.139H779.144H779.149H779.154H779.159H779.163H779.168H779.173H779.178H779.183H779.187H779.192H779.197H779.202H779.207H779.211H779.216H779.221H779.226H779.231H779.235H779.24H779.245H779.25H779.254H779.259H779.264H779.269H779.274H779.278H779.283H779.288H779.293H779.298H779.302H779.307H779.312H779.317H779.322H779.326H779.331H779.336H779.341H779.346H779.35H779.355H779.36H779.365H779.37H779.374H779.379H779.384H779.389H779.394H779.398H779.403H779.408H779.413H779.417H779.422H779.427H779.432H779.437H779.441H779.446H779.451H779.456H779.461H779.465H779.47H779.475H779.48H779.485H779.489H779.494H779.499H779.504H779.509H779.513H779.518H779.523H779.528H779.533H779.537H779.542H779.547H779.552H779.557H779.561H779.566H779.571H779.576H779.58H779.585H779.59H779.595H779.6H779.604H779.609H779.614H779.619H779.624H779.628H779.633H779.638H779.643H779.648H779.652H779.657H779.662H779.667H779.672H779.676H779.681H779.686H779.691H779.696H779.7H779.705H779.71H779.715H779.719H779.724H779.729H779.734H779.739H779.743H779.748H779.753H779.758H779.763H779.767H779.772H779.777H779.782H779.787H779.791H779.796H779.801H779.806H779.811H779.815H779.82H779.825H779.83H779.835H779.839H779.844H779.849H779.854H779.859H779.863H779.868H779.873H779.878H779.882H779.887H779.892H779.897H779.902H779.906H779.911H779.916H779.921H779.926H779.93H779.935H779.94H779.945H779.95H779.954H779.959H779.964H779.969H779.974H779.978H779.983H779.988H779.993H779.998H780.002H780.007H780.012H780.017H780.022H780.026H780.031H780.036H780.041H780.045H780.05H780.055H780.06H780.065H780.069H780.074H780.079H780.084H780.089H780.093H780.098H780.103H780.108H780.113H780.117H780.122H780.127H780.132H780.137H780.141H780.146H780.151H780.156H780.161H780.165H780.17H780.175H780.18H780.185H780.189H780.194H780.199H780.204H780.208H780.213H780.218H780.223H780.228H780.232H780.237H780.242H780.247H780.252H780.256H780.261H780.266H780.271H780.276H780.28H780.285H780.29H780.295H780.3H780.304H780.309H780.314H780.319H780.324H780.328H780.333H780.338H780.343H780.348H780.352H780.357H780.362H780.367H780.371H780.376H780.381H780.386H780.391H780.395H780.4H780.405H780.41H780.415H780.419H780.424H780.429H780.434H780.439H780.443H780.448H780.453H780.458H780.463H780.467H780.472H780.477H780.482H780.487H780.491H780.496H780.501H780.506H780.511H780.515H780.52H780.525H780.53H780.534H780.539H780.544H780.549H780.554H780.558H780.563H780.568H780.573H780.578H780.582H780.587H780.592H780.597H780.602H780.606H780.611H780.616H780.621H780.626H780.63H780.635H780.64H780.645H780.65H780.654H780.659H780.664H780.669H780.674H780.678H780.683H780.688H780.693H780.697H780.702H780.707H780.712H780.717C785.866 1166 791.019 1165.75 796.027 1165.44L796.027 1165.44L796.034 1165.44L796.605 1165.41L796.454 1162.63L795.878 1162.66C795.391 1162.68 794.902 1162.71 794.412 1162.73Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M724.529 1165.95V1163.17H690.808V1165.95H724.529Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M637.228 1163.17H618.91V1166H637.228H655.547V1163.17H637.228Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M583.445 1165.95V1163.17H549.723V1165.95H583.445Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M496.144 1163.17H477.825V1166H496.144H514.462V1163.17H496.144Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M442.36 1165.95V1163.17H408.638V1165.95H442.36Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M355.059 1163.17H336.741V1166H355.059H373.377V1163.17H355.059Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M301.275 1165.95V1163.17H267.553V1165.95H301.275Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M213.974 1163.17H195.656V1166H213.974H232.292V1163.17H213.974Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M160.19 1166V1163.17H126.469V1165.96L131.338 1166H131.34H160.19Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M82.1911 1168.41L73.6349 1171.55L74.125 1172.87L73.1988 1173.25L72.6321 1171.97C67.2362 1174.3 61.6166 1176.83 56.3974 1180.2L57.9014 1182.53C63.1412 1179.17 68.7934 1176.62 74.1235 1174.33L74.1365 1174.32L74.1499 1174.32L82.9964 1171.09L83.0197 1171.09L83.0437 1171.08L91.5618 1168.9L90.8839 1166.19L82.1911 1168.41Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1124 1233.19C17.6919 1222.89 23.675 1213.52 30.9682 1205.25L28.9017 1203.41C21.4239 1211.86 15.2914 1221.5 10.5988 1232.06L13.1124 1233.19Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M5.45926 1302.87L5.45922 1302.87L5.45831 1302.86C5.43969 1302.75 5.42104 1302.63 5.40237 1302.52C4.52579 1297.11 3.61314 1291.49 3.51522 1285.89H2.11668L2.08968 1284.89L3.48332 1284.82C3.33996 1282.05 3.21535 1279.03 3.45851 1276.11C3.48392 1275.55 3.50934 1274.98 3.53476 1274.4C3.56033 1273.83 3.58591 1273.25 3.61149 1272.69L3.61148 1272.69L3.61163 1272.69C3.63123 1272.3 3.64899 1271.92 3.66676 1271.54C3.73337 1270.11 3.80009 1268.67 3.96413 1267.22L1.22442 1266.88C1.01384 1268.74 0.920413 1270.65 0.826333 1272.58C0.800766 1273.14 0.775202 1273.69 0.749651 1274.24L0.749641 1274.24C0.724077 1274.79 0.698526 1275.34 0.672975 1275.91L0.67243 1275.92L0.671308 1275.93C0.368475 1279.16 0.519255 1282.45 0.723605 1285.57L0.724538 1285.58L0.724658 1285.59C0.775408 1291.58 1.7397 1297.53 2.71181 1303.31C2.71189 1303.31 2.71197 1303.31 2.71205 1303.31L2.83121 1304L5.57731 1303.54L5.45926 1302.87Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M65.8969 1385.26C68.9572 1386.83 72.1573 1388.13 75.4163 1389.35L75.8686 1389.51L75.8183 1389.67L81.4893 1391.74C82.7401 1392.15 83.9908 1392.47 85.2223 1392.79C85.3804 1392.83 85.5382 1392.87 85.6956 1392.91C85.6959 1392.91 85.6961 1392.91 85.6964 1392.91L87.8781 1393.47C88.7116 1393.62 89.4409 1393.83 90.1472 1394.04L90.1492 1394.04C90.4682 1394.12 90.7813 1394.2 91.0911 1394.28C92.1947 1394.56 93.2554 1394.84 94.3836 1394.99L94.3836 1394.99L94.3898 1395L100.832 1395.97C100.832 1395.97 100.832 1395.97 100.832 1395.97C103.428 1396.35 106.119 1396.6 109.082 1396.8L109.233 1394.01C106.347 1393.81 103.73 1393.51 101.253 1393.17L101.253 1393.17L101.246 1393.17L94.8117 1392.2C93.4454 1392.04 92.1375 1391.68 90.8731 1391.32L90.8596 1391.32L89.712 1391.01L88.5663 1390.71L88.5614 1390.71L86.3675 1390.15L86.3675 1390.15L86.3541 1390.14C85.9987 1390.04 85.6302 1389.94 85.259 1389.84L85.2578 1389.84C84.8879 1389.73 84.5153 1389.63 84.1552 1389.53L83.5759 1389.36L83.6375 1389.24C77.9105 1387.35 72.3434 1385.4 67.2181 1382.76L65.8969 1385.26Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M38.1656 1362.62L38.2715 1362.51C30.2332 1354.76 23.3577 1345.99 17.8812 1336.34L15.4801 1337.69C19.8106 1345.32 25.0213 1352.45 30.9683 1358.95L31.2913 1359.3L31.186 1359.41L34.036 1362.58C34.7872 1363.38 35.5403 1364.08 36.3492 1364.79L36.3493 1364.79L36.3578 1364.8L37.5808 1365.92C38.3446 1366.59 39.0637 1367.26 39.733 1367.88C39.7851 1367.93 39.837 1367.97 39.8885 1368.02L39.8899 1368.02L39.9083 1368.04C41.3746 1369.41 42.8571 1370.8 44.5343 1371.99L46.1175 1369.69C44.606 1368.6 43.2188 1367.3 41.8151 1365.99C41.0476 1365.28 40.2854 1364.56 39.4221 1363.8L39.416 1363.8L39.4102 1363.79L38.5409 1362.97L38.1656 1362.62Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M163.093 1397.19H181.412V1394.41H163.093H144.775V1397.19H163.093Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M250.599 1397.19V1394.41H216.877V1397.19H250.599Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M304.178 1397.19H322.496V1394.41H304.178H285.86V1397.19H304.178Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M391.684 1397.19V1394.41H357.962V1397.19H391.684Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M445.263 1397.19H463.581V1394.41H445.263H426.945V1397.19H445.263Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M532.769 1397.19V1394.41H499.047V1397.19H532.769Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M586.297 1397.19H604.666V1394.41H586.297H568.03V1397.19H586.297Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M673.853 1397.19V1394.41H640.132V1397.19H673.853Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M727.382 1397.19H745.7V1394.41H727.382H709.115V1397.19H727.382Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M782.302 1397.19C793.758 1397.19 804.477 1398.48 814.214 1401.02L814.928 1398.35C804.977 1395.74 793.989 1394.41 782.302 1394.41H781.172L781.21 1397.19H782.302Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M856.289 1422.75L856.306 1422.77L856.322 1422.78L859.331 1425.47L860.276 1424.45L861.022 1425.12L860.12 1426.17C864.707 1430.15 868.692 1434.77 872.106 1438.81L874.26 1437C870.698 1432.7 866.48 1427.88 861.647 1423.74L861.647 1423.74L861.638 1423.73L858.178 1420.63L852.366 1416.29L852.364 1416.29C850.598 1414.96 848.861 1413.64 846.927 1412.54L845.572 1414.98C847.094 1415.86 848.498 1416.92 849.943 1418.01C850.165 1418.17 850.388 1418.34 850.613 1418.51C850.613 1418.51 850.613 1418.51 850.613 1418.51L856.289 1422.75Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M896.34 1501.22L899.128 1501.03C898.338 1489.46 895.914 1478.28 891.857 1467.78L889.209 1468.8C893.153 1479.09 895.545 1489.96 896.34 1501.22Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M882.387 1569.63C885.617 1564.7 888.138 1559.32 890.517 1553.76L889.23 1553.19L889.606 1552.27L890.926 1552.76L893.971 1544.49C894.512 1542.83 894.915 1541.23 895.327 1539.6C895.415 1539.26 895.504 1538.9 895.595 1538.55C895.811 1537.64 896.03 1536.72 896.281 1535.8L893.632 1535.09C893.539 1535.47 893.441 1535.86 893.343 1536.24L893.343 1536.24C893.202 1536.79 893.062 1537.33 892.936 1537.87L892.936 1537.87L892.935 1537.87C892.905 1537.99 892.874 1538.12 892.844 1538.24C892.414 1540.01 891.97 1541.84 891.39 1543.59L891.39 1543.59L891.385 1543.6L888.266 1552.19L888.259 1552.21L888.252 1552.22C885.765 1557.74 883.217 1563.15 880.047 1568.08L882.387 1569.63Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M830.483 1614.57C841.239 1609.97 850.932 1603.94 859.375 1596.56L857.527 1594.45C849.305 1601.6 839.83 1607.48 829.387 1611.96L830.483 1614.57Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M794.414 1620.71C789.315 1620.99 784.085 1621.27 778.851 1621.2L778.813 1622.6L777.813 1622.59V1621.19H759.995V1623.98H778.262H778.267H778.272H778.277H778.281H778.286H778.291H778.296H778.3H778.305H778.31H778.315H778.32H778.324H778.329H778.334H778.339H778.344H778.348H778.353H778.358H778.363H778.368H778.372H778.377H778.382H778.387H778.392H778.396H778.401H778.406H778.411H778.416H778.42H778.425H778.43H778.435H778.439H778.444H778.449H778.454H778.459H778.463H778.468H778.473H778.478H778.483H778.487H778.492H778.497H778.502H778.507H778.511H778.516H778.521H778.526H778.531H778.535H778.54H778.545H778.55H778.555H778.559H778.564H778.569H778.574H778.579H778.583H778.588H778.593H778.598H778.602H778.607H778.612H778.617H778.622H778.626H778.631H778.636H778.641H778.646H778.65H778.655H778.66H778.665H778.67H778.674H778.679H778.684H778.689H778.694H778.698H778.703H778.708H778.713H778.718H778.722H778.727H778.732H778.737H778.742H778.746H778.751H778.756H778.761H778.765H778.77H778.775H778.78H778.785H778.789H778.794H778.799H778.804H778.809H778.813H778.818H778.823H778.828H778.833H778.837H778.842H778.847H778.852H778.857H778.861H778.866H778.871H778.876H778.881H778.885H778.89H778.895H778.9H778.905H778.909H778.914H778.919H778.924H778.928H778.933H778.938H778.943H778.948H778.952H778.957H778.962H778.967H778.972H778.976H778.981H778.986H778.991H778.996H779H779.005H779.01H779.015H779.02H779.024H779.029H779.034H779.039H779.044H779.048H779.053H779.058H779.063H779.068H779.072H779.077H779.082H779.087H779.091H779.096H779.101H779.106H779.111H779.115H779.12H779.125H779.13H779.135H779.139H779.144H779.149H779.154H779.159H779.163H779.168H779.173H779.178H779.183H779.187H779.192H779.197H779.202H779.207H779.211H779.216H779.221H779.226H779.231H779.235H779.24H779.245H779.25H779.254H779.259H779.264H779.269H779.274H779.278H779.283H779.288H779.293H779.298H779.302H779.307H779.312H779.317H779.322H779.326H779.331H779.336H779.341H779.346H779.35H779.355H779.36H779.365H779.37H779.374H779.379H779.384H779.389H779.394H779.398H779.403H779.408H779.413H779.417H779.422H779.427H779.432H779.437H779.441H779.446H779.451H779.456H779.461H779.465H779.47H779.475H779.48H779.485H779.489H779.494H779.499H779.504H779.509H779.513H779.518H779.523H779.528H779.533H779.537H779.542H779.547H779.552H779.557H779.561H779.566H779.571H779.576H779.58H779.585H779.59H779.595H779.6H779.604H779.609H779.614H779.619H779.624H779.628H779.633H779.638H779.643H779.648H779.652H779.657H779.662H779.667H779.672H779.676H779.681H779.686H779.691H779.696H779.7H779.705H779.71H779.715H779.719H779.724H779.729H779.734H779.739H779.743H779.748H779.753H779.758H779.763H779.767H779.772H779.777H779.782H779.787H779.791H779.796H779.801H779.806H779.811H779.815H779.82H779.825H779.83H779.835H779.839H779.844H779.849H779.854H779.859H779.863H779.868H779.873H779.878H779.882H779.887H779.892H779.897H779.902H779.906H779.911H779.916H779.921H779.926H779.93H779.935H779.94H779.945H779.95H779.954H779.959H779.964H779.969H779.974H779.978H779.983H779.988H779.993H779.998H780.002H780.007H780.012H780.017H780.022H780.026H780.031H780.036H780.041H780.045H780.05H780.055H780.06H780.065H780.069H780.074H780.079H780.084H780.089H780.093H780.098H780.103H780.108H780.113H780.117H780.122H780.127H780.132H780.137H780.141H780.146H780.151H780.156H780.161H780.165H780.17H780.175H780.18H780.185H780.189H780.194H780.199H780.204H780.208H780.213H780.218H780.223H780.228H780.232H780.237H780.242H780.247H780.252H780.256H780.261H780.266H780.271H780.276H780.28H780.285H780.29H780.295H780.3H780.304H780.309H780.314H780.319H780.324H780.328H780.333H780.338H780.343H780.348H780.352H780.357H780.362H780.367H780.371H780.376H780.381H780.386H780.391H780.395H780.4H780.405H780.41H780.415H780.419H780.424H780.429H780.434H780.439H780.443H780.448H780.453H780.458H780.463H780.467H780.472H780.477H780.482H780.487H780.491H780.496H780.501H780.506H780.511H780.515H780.52H780.525H780.53H780.534H780.539H780.544H780.549H780.554H780.558H780.563H780.568H780.573H780.578H780.582H780.587H780.592H780.597H780.602H780.606H780.611H780.616H780.621H780.626H780.63H780.635H780.64H780.645H780.65H780.654H780.659H780.664H780.669H780.674H780.678H780.683H780.688H780.693H780.697H780.702H780.707H780.712H780.717C785.866 1623.98 791.019 1623.72 796.027 1623.42L796.027 1623.42L796.034 1623.42L796.605 1623.39L796.454 1620.6L795.878 1620.63C795.391 1620.66 794.903 1620.68 794.414 1620.71Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M724.529 1623.93V1621.14H690.808V1623.93H724.529Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M637.228 1621.14H618.91V1623.98H637.228H655.547V1621.14H637.228Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M583.445 1623.93V1621.14H549.723V1623.93H583.445Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M496.144 1621.14H477.825V1623.98H496.144H514.462V1621.14H496.144Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M442.36 1623.93V1621.14H408.638V1623.93H442.36Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M355.059 1621.14H336.741V1623.98H355.059H373.377V1621.14H355.059Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M301.275 1623.93V1621.14H267.553V1623.93H301.275Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M213.974 1621.14H195.656V1623.98H213.974H232.292V1621.14H213.974Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M160.19 1623.98V1621.14H126.469V1623.98H131.338H160.19Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M82.1911 1626.39L73.6349 1629.53L74.125 1630.85L73.1988 1631.23L72.6321 1629.94C67.2362 1632.28 61.6166 1634.8 56.3974 1638.18L57.9014 1640.51C63.1412 1637.14 68.7934 1634.59 74.1235 1632.3L74.1365 1632.3L74.1499 1632.29L82.9964 1629.07L83.0197 1629.06L83.0437 1629.06L91.5618 1626.88L90.8839 1624.17L82.1911 1626.39Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1124 1691.16C17.6919 1680.87 23.675 1671.49 30.9682 1663.23L28.9017 1661.39C21.4239 1669.83 15.2914 1679.47 10.5988 1690.04L13.1124 1691.16Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M5.45926 1760.84L5.45922 1760.84L5.45831 1760.84C5.43967 1760.72 5.42101 1760.61 5.40233 1760.49C4.52577 1755.09 3.61314 1749.46 3.51522 1743.87H2.11668L2.08966 1742.87L3.48332 1742.8C3.33996 1740.02 3.21537 1737.01 3.45847 1734.08C3.50949 1732.91 3.5605 1731.79 3.61149 1730.67L3.61148 1730.67L3.61163 1730.66C3.63123 1730.28 3.64899 1729.9 3.66676 1729.52C3.73337 1728.08 3.80009 1726.65 3.96413 1725.19L1.22442 1724.85C1.01384 1726.72 0.920413 1728.63 0.826333 1730.56C0.800766 1731.12 0.775202 1731.67 0.749651 1732.22L0.749644 1732.22C0.724079 1732.77 0.698527 1733.32 0.672975 1733.88L0.67243 1733.89L0.671308 1733.91C0.368475 1737.14 0.519255 1740.43 0.723605 1743.54L0.724538 1743.56L0.724658 1743.57C0.775408 1749.56 1.7397 1755.5 2.71182 1761.29C2.71189 1761.29 2.71197 1761.29 2.71205 1761.29L2.83122 1761.97L5.57731 1761.52L5.45926 1760.84Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9561 1815.06L32.9488 1815.05L32.9417 1815.04C27.1473 1808.75 22.094 1801.85 17.8307 1794.37L15.4288 1795.72C19.8109 1803.44 25.1226 1810.63 31.1726 1817.23L34.0324 1820.35C34.033 1820.35 34.0336 1820.35 34.0342 1820.35C34.786 1821.15 35.5397 1821.85 36.3492 1822.56L36.3617 1822.57L36.3734 1822.58L36.5779 1822.79L36.578 1822.79L36.6547 1822.87L36.7204 1822.93L37.5764 1823.69C37.5768 1823.69 37.5771 1823.69 37.5774 1823.69C38.3446 1824.36 39.0668 1825.03 39.7387 1825.65C39.7889 1825.7 39.8389 1825.75 39.8885 1825.79L39.8899 1825.79L39.9099 1825.81C41.3756 1827.18 42.8577 1828.57 44.5343 1829.76L46.1175 1827.46C44.606 1826.37 43.2188 1825.07 41.8151 1823.76C41.046 1823.05 40.2913 1822.34 39.4887 1821.69L39.4742 1821.68L39.4606 1821.67L38.5403 1820.8C36.689 1819.05 34.9432 1817.2 33.2553 1815.36L32.9561 1815.06Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2232 1840.74L65.942 1843.23C70.4323 1845.55 75.2116 1847.32 80.1581 1849L80.1581 1849L80.1707 1849.01L81.5263 1849.51C81.6254 1849.54 81.713 1849.56 81.7939 1849.58L81.7964 1849.58C81.8865 1849.61 81.9685 1849.63 82.0616 1849.66L82.0892 1849.66L82.1159 1849.67C82.2943 1849.74 82.4745 1849.8 82.6675 1849.86V1849.85L83.2964 1850.02C83.6378 1850.11 83.9711 1850.2 84.3044 1850.3C84.7598 1850.43 85.2153 1850.56 85.6922 1850.68L85.6948 1850.68L87.8781 1851.24C88.7116 1851.4 89.4409 1851.6 90.1472 1851.81L90.1492 1851.81C90.4687 1851.89 90.7822 1851.97 91.0924 1852.05C92.1956 1852.34 93.2558 1852.61 94.3836 1852.77L94.3836 1852.77L94.3898 1852.77L100.832 1853.74C100.832 1853.74 100.832 1853.74 100.832 1853.74C103.428 1854.12 106.119 1854.37 109.082 1854.57L109.233 1851.78C106.347 1851.58 103.73 1851.28 101.253 1850.94L101.253 1850.94L101.246 1850.94L94.8117 1849.97C93.4464 1849.81 92.1393 1849.45 90.8758 1849.09L90.8596 1849.09L88.5663 1848.48L88.5614 1848.48L86.3675 1847.92L86.3675 1847.92L86.3599 1847.91C85.7959 1847.76 85.2449 1847.61 84.6955 1847.45L84.6951 1847.45C84.1451 1847.3 83.5968 1847.15 83.036 1846.99L83.036 1846.99L83.0302 1846.99C82.3103 1846.79 81.6302 1846.58 80.9463 1846.31L76.3508 1844.63C76.3503 1844.63 76.3497 1844.63 76.3492 1844.63C73.2238 1843.51 70.1364 1842.24 67.2232 1840.74Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M163.093 1854.96H181.412V1852.18H163.093H144.775V1854.96H163.093Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M250.599 1854.96V1852.18H216.877V1854.96H250.599Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M304.178 1854.96H322.496V1852.18H304.178H285.86V1854.96H304.178Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M391.684 1854.96V1852.18H357.962V1854.96H391.684Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M445.263 1854.96H463.581V1852.18H445.263H426.945V1854.96H445.263Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M532.769 1854.96V1852.18H499.047V1854.96H532.769Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M586.297 1854.96H604.666V1852.18H586.297H568.03V1854.96H586.297Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M673.853 1854.96V1852.18H640.132V1854.96H673.853Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M727.382 1854.96H745.7V1852.18H727.382H709.115V1854.96H727.382Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M782.302 1854.96C793.758 1854.96 804.477 1856.25 814.214 1858.79L814.928 1856.12C804.977 1853.51 793.989 1852.18 782.302 1852.18H781.172L781.21 1854.96H782.302Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M856.289 1880.53L856.308 1880.54L856.325 1880.56L859.334 1883.29L860.276 1882.27L861.022 1882.94L860.12 1883.99C864.707 1887.97 868.692 1892.59 872.106 1896.64L874.26 1894.82C870.698 1890.52 866.48 1885.7 861.647 1881.56L861.647 1881.56L861.638 1881.55L858.177 1878.45L852.364 1874.06L852.364 1874.06C850.598 1872.73 848.861 1871.41 846.927 1870.31L845.572 1872.75C847.095 1873.63 848.499 1874.69 849.944 1875.78C850.166 1875.95 850.389 1876.11 850.613 1876.28L856.289 1880.53Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M896.34 1958.99L899.128 1958.8C898.338 1947.23 895.914 1936.06 891.857 1925.55L889.209 1926.57C893.153 1936.86 895.545 1947.73 896.34 1958.99Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M882.387 2027.4C885.618 2022.47 888.14 2017.13 890.518 2011.53L889.23 2010.96L889.606 2010.04L890.926 2010.53L893.971 2002.26C894.512 2000.6 894.915 1999 895.327 1997.37C895.415 1997.03 895.504 1996.68 895.595 1996.32L895.595 1996.32C895.811 1995.41 896.03 1994.49 896.281 1993.57L893.632 1992.87C893.539 1993.24 893.441 1993.63 893.343 1994.01L893.343 1994.01C893.202 1994.56 893.062 1995.11 892.936 1995.64L892.936 1995.64L892.935 1995.64C892.905 1995.77 892.875 1995.89 892.844 1996.01C892.414 1997.79 891.97 1999.61 891.39 2001.36L891.39 2001.36L891.385 2001.37L888.266 2009.96L888.259 2009.98L888.252 2009.99C885.765 2015.52 883.217 2020.92 880.047 2025.86L882.387 2027.4Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M830.483 2072.34C841.239 2067.74 850.932 2061.71 859.375 2054.33L857.527 2052.22C849.305 2059.37 839.83 2065.25 829.387 2069.73L830.483 2072.34Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M795.88 2078.4C790.313 2078.75 784.586 2079.05 778.851 2078.97L778.813 2080.37L777.813 2080.36V2078.97H759.995V2081.75H778.262H778.267H778.272H778.277H778.281H778.286H778.291H778.296H778.3H778.305H778.31H778.315H778.32H778.324H778.329H778.334H778.339H778.344H778.348H778.353H778.358H778.363H778.368H778.372H778.377H778.382H778.387H778.392H778.396H778.401H778.406H778.411H778.416H778.42H778.425H778.43H778.435H778.439H778.444H778.449H778.454H778.459H778.463H778.468H778.473H778.478H778.483H778.487H778.492H778.497H778.502H778.507H778.511H778.516H778.521H778.526H778.531H778.535H778.54H778.545H778.55H778.555H778.559H778.564H778.569H778.574H778.579H778.583H778.588H778.593H778.598H778.602H778.607H778.612H778.617H778.622H778.626H778.631H778.636H778.641H778.646H778.65H778.655H778.66H778.665H778.67H778.674H778.679H778.684H778.689H778.694H778.698H778.703H778.708H778.713H778.718H778.722H778.727H778.732H778.737H778.742H778.746H778.751H778.756H778.761H778.765H778.77H778.775H778.78H778.785H778.789H778.794H778.799H778.804H778.809H778.813H778.818H778.823H778.828H778.833H778.837H778.842H778.847H778.852H778.857H778.861H778.866H778.871H778.876H778.881H778.885H778.89H778.895H778.9H778.905H778.909H778.914H778.919H778.924H778.928H778.933H778.938H778.943H778.948H778.952H778.957H778.962H778.967H778.972H778.976H778.981H778.986H778.991H778.996H779H779.005H779.01H779.015H779.02H779.024H779.029H779.034H779.039H779.044H779.048H779.053H779.058H779.063H779.068H779.072H779.077H779.082H779.087H779.091H779.096H779.101H779.106H779.111H779.115H779.12H779.125H779.13H779.135H779.139H779.144H779.149H779.154H779.159H779.163H779.168H779.173H779.178H779.183H779.187H779.192H779.197H779.202H779.207H779.211H779.216H779.221H779.226H779.231H779.235H779.24H779.245H779.25H779.254H779.259H779.264H779.269H779.274H779.278H779.283H779.288H779.293H779.298H779.302H779.307H779.312H779.317H779.322H779.326H779.331H779.336H779.341H779.346H779.35H779.355H779.36H779.365H779.37H779.374H779.379H779.384H779.389H779.394H779.398H779.403H779.408H779.413H779.417H779.422H779.427H779.432H779.437H779.441H779.446H779.451H779.456H779.461H779.465H779.47H779.475H779.48H779.485H779.489H779.494H779.499H779.504H779.509H779.513H779.518H779.523H779.528H779.533H779.537H779.542H779.547H779.552H779.557H779.561H779.566H779.571H779.576H779.58H779.585H779.59H779.595H779.6H779.604H779.609H779.614H779.619H779.624H779.628H779.633H779.638H779.643H779.648H779.652H779.657H779.662H779.667H779.672H779.676H779.681H779.686H779.691H779.696H779.7H779.705H779.71H779.715H779.719H779.724H779.729H779.734H779.739H779.743H779.748H779.753H779.758H779.763H779.767H779.772H779.777H779.782H779.787H779.791H779.796H779.801H779.806H779.811H779.815H779.82H779.825H779.83H779.835H779.839H779.844H779.849H779.854H779.859H779.863H779.868H779.873H779.878H779.882H779.887H779.892H779.897H779.902H779.906H779.911H779.916H779.921H779.926H779.93H779.935H779.94H779.945H779.95H779.954H779.959H779.964H779.969H779.974H779.978H779.983H779.988H779.993H779.998H780.002H780.007H780.012H780.017H780.022H780.026H780.031H780.036H780.041H780.045H780.05H780.055H780.06H780.065H780.069H780.074H780.079H780.084H780.089H780.093H780.098H780.103H780.108H780.113H780.117H780.122H780.127H780.132H780.137H780.141H780.146H780.151H780.156H780.161H780.165H780.17H780.175H780.18H780.185H780.189H780.194H780.199H780.204H780.208H780.213H780.218H780.223H780.228H780.232H780.237H780.242H780.247H780.252H780.256H780.261H780.266H780.271H780.276H780.28H780.285H780.29H780.295H780.3H780.304H780.309H780.314H780.319H780.324H780.328H780.333H780.338H780.343H780.348H780.352H780.357H780.362H780.367H780.371H780.376H780.381H780.386H780.391H780.395H780.4H780.405H780.41H780.415H780.419H780.424H780.429H780.434H780.439H780.443H780.448H780.453H780.458H780.463H780.467H780.472H780.477H780.482H780.487H780.491H780.496H780.501H780.506H780.511H780.515H780.52H780.525H780.53H780.534H780.539H780.544H780.549H780.554H780.558H780.563H780.568H780.573H780.578H780.582H780.587H780.592H780.597H780.602H780.606H780.611H780.616H780.621H780.626H780.63H780.635H780.64H780.645H780.65H780.654H780.659H780.664H780.669H780.674H780.678H780.683H780.688H780.693H780.697H780.702H780.707H780.712H780.717C785.866 2081.75 791.019 2081.49 796.027 2081.19L796.027 2081.19L796.034 2081.19L796.605 2081.16L796.454 2078.37L795.88 2078.4Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M724.529 2081.75V2078.97H690.808V2081.75H724.529Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M637.228 2078.97H618.91V2081.75H637.228H655.547V2078.97H637.228Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M583.445 2081.75V2078.97H549.723V2081.75H583.445Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M496.144 2078.97H477.825V2081.75H496.144H514.462V2078.97H496.144Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M442.36 2081.75V2078.97H408.638V2081.75H442.36Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M355.059 2078.97H336.741V2081.75H355.059H373.377V2078.97H355.059Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M301.275 2081.75V2078.97H267.553V2081.75H301.275Z",
  fill: "white",
  stroke: "#1E2835"
});

var _ref142 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 23,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref143 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 23,
  r: 10,
  fill: "#AEFF00"
});

var _ref144 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 471,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref145 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 471,
  r: 10,
  fill: "#AEFF00"
});

var _ref146 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 251,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref147 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 251,
  r: 10,
  fill: "#AEFF00"
});

var _ref148 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 707,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref149 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 707,
  r: 10,
  fill: "#AEFF00"
});

var _ref150 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 1165,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref151 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 1165,
  r: 10,
  fill: "#AEFF00"
});

var _ref152 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 1623,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref153 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 1623,
  r: 10,
  fill: "#AEFF00"
});

var _ref154 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 2080,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref155 = /*#__PURE__*/React.createElement("circle", {
  cx: 245,
  cy: 2080,
  r: 10,
  fill: "#AEFF00"
});

var _ref156 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 927,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref157 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 927,
  r: 10,
  fill: "#AEFF00"
});

var _ref158 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 1383,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref159 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 1383,
  r: 10,
  fill: "#AEFF00"
});

var _ref160 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 1839,
  r: 22,
  fill: "#1E2835",
  stroke: "#AEFF00"
});

var _ref161 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 1839,
  r: 10,
  fill: "#AEFF00"
});

function SvgGhostRoadMapTabs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 2103,
    viewBox: "0 0 900 2103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostRoadMapTabs);
export default __webpack_public_path__ + "static/media/ghostRoadMapTabs.3987e0fa5d3d27e1c9764d567a7c9cc9.svg";
export { ForwardRef as ReactComponent };